module.exports = __webpack_public_path__ + "img/authenticationSuccess.998aadca.svg";